import { FunctionComponent } from "react";
import {
  applyOpacityToHexColor,
  FontIcon,
  Stack,
  Text,
  useTheme
} from "@bps/fluent-ui";

export const UserSecurityLegend: FunctionComponent = () => {
  const theme = useTheme();
  const transparentPrimary = applyOpacityToHexColor(
    theme.palette.themePrimary,
    10
  );

  return (
    <Stack tokens={{ childrenGap: 8 }}>
      <Stack horizontal tokens={{ childrenGap: 10 }} verticalAlign="center">
        <FontIcon
          iconName="BPCheckedOut"
          styles={{
            root: {
              color: theme.semanticColors.successIcon,
              fontSize: 24
            }
          }}
        />
        <Text variant="small">
          Effective Security Role. Role that user receives and can be different
          to Assigned Security Role if Assigned Security Role requirements
          (licence or component) are not met.
        </Text>
      </Stack>

      <Stack horizontal tokens={{ childrenGap: 10 }} verticalAlign="center">
        <FontIcon
          iconName="Lock"
          styles={{
            root: {
              color: theme.semanticColors.errorIcon,
              fontSize: 24
            }
          }}
        />
        <Text variant="small">System managed Security Role.</Text>
      </Stack>

      <Stack horizontal tokens={{ childrenGap: 10 }} verticalAlign="center">
        <FontIcon
          iconName="CheckboxFill"
          styles={{
            root: {
              color: transparentPrimary,
              borderWidth: 1,
              borderStyle: "solid",
              borderColor: theme.palette.themePrimary,
              fontSize: 24
            }
          }}
        />
        <Text variant="small">
          Assigned Security Role. Assigned to user either based on default
          configuration for Business Role or it is an override.
        </Text>
      </Stack>
    </Stack>
  );
};
